import { useApi } from '@/composables/useApi'

const api = useApi()

export function ActiveCampaignService() {
  this.CreateActiveCampaign = function (params) {
    return new Promise((resolve, reject) => {
      try {
        api.post('/activeCampaign', params)
          .then(resp => {
            resolve(resp.data[0])
          })
      } catch (error) {
        reject(error)
      }
    })
  }

  this.tagActiveCampaign = function (params) {
    return new Promise((resolve, reject) => {
      try {
        api.get(`/activeCampaign/tag/${params}`)
          .then(resp => {
            resolve(resp.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }
}
